import crudApi from "./crudApi";
import {API_TRANSPORT_TEMPLATES} from '../api.js'

class TransportTemplate extends crudApi{}

export default new TransportTemplate(API_TRANSPORT_TEMPLATES)
